<template>
  <div class="app sticky-footer">
    <div class="wrapper">
      <SiteHeader :key="locale" />
      <NuxtPage />
    </div>
    <SiteFooter :key="locale" class="footer" />
    <CookieConsent />
  </div>
</template>

<script setup lang="ts">
import { initLayoutConfig, alumniNavigationConfig } from '~/app/layout.config';
import CookieConsent from '~/components/content-modules/CookieConsent.vue';

const { locale } = useI18n();

initLayoutConfig(alumniNavigationConfig);
</script>

<style scoped lang="scss"></style>
